// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__07F9u","loader":"MediumLoader_loader__wUH-O","spinner-c7wet2":"MediumLoader_spinner-c7wet2__WTliO"};